// src/utils/VariacaoUtils.js
export const obterGruposVariacao = produto => [...(produto?.produtoVariacoes || [])].sort((a,b) => Number(a.id)-Number(b.id));
export const criarEscolhasVariacao = (produto, escolhas = [], legado = null, aplicarPadroes = true) => {
  escolhas = escolhas || [];
  const grupos = obterGruposVariacao(produto);
  return grupos.flatMap(grupo => {
    const itens = grupo.variacao?.variacaoItens || [];
    const anteriores = escolhas.filter(v => Number(v.variacaoId) === Number(grupo.variacaoId));
    if (anteriores.length > 1) return [];
    const anterior = anteriores.length === 1 ? anteriores[0] : null;
    let item = itens.find(i => Number(i.id) === Number(anterior?.variacaoItemId));
    if (!item && grupos.length === 1 && legado) {
      const correspondentes = itens.filter(i => i.descricao?.trim().toLocaleLowerCase('pt-BR') === legado.trim().toLocaleLowerCase('pt-BR'));
      if (correspondentes.length === 1) item = correspondentes[0];
    }
    if (!item && !anteriores.length && !legado && aplicarPadroes) {
      const padroes = itens.filter(i => i.isDefault === true);
      if (padroes.length === 1) item = padroes[0];
    }
    return item ? [{ id: anterior?.id || 0, variacaoId: Number(grupo.variacaoId), variacaoItemId: Number(item.id),
      nomeVariacao: grupo.variacao?.descricao || 'Variação', descricao: item.descricao,
      valorAdicionalUnitario: Number(item.valorAdicional || 0) }] : [];
  });
};
export const selecionarItemVariacao = (produto, escolhas, variacaoId, variacaoItemId) => criarEscolhasVariacao(produto,
  [...(escolhas || []).filter(v => Number(v.variacaoId) !== Number(variacaoId)),
    { ...(escolhas || []).find(v => Number(v.variacaoId) === Number(variacaoId)), variacaoId: Number(variacaoId), variacaoItemId: Number(variacaoItemId) }], null, false);
export const obterErrosVariacoes = (produto, escolhas = []) => {
  escolhas = escolhas || [];
  const erros = {};
  obterGruposVariacao(produto).forEach(grupo => {
    const selecoes = escolhas.filter(v => Number(v.variacaoId) === Number(grupo.variacaoId));
    if (selecoes.length !== 1 || !(grupo.variacao?.variacaoItens || []).some(i => Number(i.id) === Number(selecoes[0]?.variacaoItemId)))
      erros[grupo.variacaoId] = 'Selecione ' + (grupo.variacao?.descricao || 'a variação') + '.';
  });
  return erros;
};
export const valorAdicionalVariacoes = escolhas => (escolhas || []).reduce((total,v) => total + Number(v.valorAdicionalUnitario || 0),0);
export const formatarVariacoes = item => item?.pedidoItemVariacoes?.length
  ? item.pedidoItemVariacoes.map(v => v.nomeVariacao + ': ' + v.descricao).join('; ')
  : item?.variacao || '';
